import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue } from "firebase/database";

let conf = {
  apiKey: 'AIzaSyCLC3udMECGbsMklSXTvUQDL9q5vTbBXW8',
  authDomain: 'salesops-admin.firebaseapp.com',
  databaseURL: 'https://salesops-admin-default-rtdb.firebaseio.com',
  projectId: 'salesops-admin',
  messagingSenderId: '1037679174387',
  appId: '1:1037679174387:web:1b8fa98539e8077eba0d86',
  measurementId: "G-807GK0HYFN"
}

export const fb = initializeApp(conf)
export const db = getDatabase();
export const table = ref(db, 'dev/mktops');
export const watchData = onValue
